// Small numbers with a label, and the bar chart on the usage page.
import type { ReactNode } from 'react';
import { cx } from '@/lib/cx';

/** Two numbers to a row, four from 640px with `four`. `big`: large numbers without hairlines, for a page's summary. */
export function StatGrid({ children, four, big }: { children: ReactNode; four?: boolean; big?: boolean }) {
  return <div className={cx('stats', four && 'four', big && 'big')}>{children}</div>;
}

/** A number with a label, and optionally its change (pass a Delta). */
export function Stat({ label, value, change }: { label: string; value: ReactNode; change?: ReactNode }) {
  return (
    <div className="stat">
      <p className="label">{label}</p>
      <p className="value">{value}</p>
      {change}
    </div>
  );
}

/** Simple bar chart (usage per day). The last bar is today. */
export function Bars({ bars, label }: { bars: readonly { label: string; value: number }[]; label: string }) {
  const max = Math.max(...bars.map((b) => b.value), 1);
  return (
    <div className="bars" role="img" aria-label={label}>
      {bars.map((b, i) => (
        <span
          key={b.label}
          title={`${b.label}: ${b.value}`}
          className={i === bars.length - 1 ? 'now' : undefined}
          style={{ height: `${(b.value / max) * 100}%` }}
        />
      ))}
    </div>
  );
}
